var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var FeedItemType;
(function (FeedItemType) {
    FeedItemType["post"] = "post";
    FeedItemType["stackedPost"] = "stackedPost";
    FeedItemType["recommendation"] = "recommendation";
    FeedItemType["surveys"] = "surveys";
    FeedItemType["availableCourses"] = "availableCourses";
    FeedItemType["assignedCourses"] = "assignedCourses";
    FeedItemType["courses"] = "courses";
    FeedItemType["content"] = "content";
    FeedItemType["activeJourneys"] = "activeJourneys";
})(FeedItemType || (FeedItemType = {}));
export var MentionType;
(function (MentionType) {
    MentionType["department"] = "department";
    MentionType["group"] = "group";
    MentionType["profile"] = "profile";
})(MentionType || (MentionType = {}));
export var PostedByType;
(function (PostedByType) {
    PostedByType["Department"] = "department";
    PostedByType["User"] = "user";
    PostedByType["Tenant"] = "tenant";
    PostedByType["Anonymous"] = "anonymous";
})(PostedByType || (PostedByType = {}));
export var PostType;
(function (PostType) {
    PostType["Text"] = "text";
    PostType["Image"] = "image";
    PostType["Video"] = "video";
    PostType["Kudos"] = "kudos";
    PostType["SharedPost"] = "sharedPost";
    PostType["Poll"] = "poll";
    PostType["Goal"] = "goal";
    PostType["Value"] = "value";
    PostType["Badge"] = "badge";
    PostType["Reel"] = "reel";
    PostType["Course"] = "course";
    PostType["KnowledgeRequest"] = "knowledgeRequest";
    PostType["CalendarEvent"] = "calendarEvent";
})(PostType || (PostType = {}));
export var PostAudienceType;
(function (PostAudienceType) {
    PostAudienceType["Department"] = "department";
    PostAudienceType["Followers"] = "followers";
    PostAudienceType["Group"] = "group";
    PostAudienceType["Organisation"] = "organisation";
    PostAudienceType["Composite"] = "composite";
})(PostAudienceType || (PostAudienceType = {}));
export var TextContentTypes = ["text/plain"];
export var ImageContentTypes = ["image/png", "image/jpeg", "image/gif", "image/webp"];
export var VideoContentTypes = ["video/mp4", "video/quicktime"];
export var MediaPreviewContentTypes = ["image/preview", "video/preview"];
export var PollConentTypes = ["post/poll"];
export var GoalContentTypes = ["post/goal"];
export var ValueContentTypes = ["post/value"];
export var BadgeContentTypes = ["post/badge"];
export var ReelContentTypes = ["post/reel"];
export var CoursePostContentTypes = ["post/course"];
export var FileContentTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
];
export var MetaPostContentTypes = ["post/shared", "post/kudos", "post/link-preview"];
export var AssetContentTypes = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], ImageContentTypes, true), VideoContentTypes, true), FileContentTypes, true), MediaPreviewContentTypes, true);
export var KnowledgeRequestPriority;
(function (KnowledgeRequestPriority) {
    KnowledgeRequestPriority["Low"] = "low";
    KnowledgeRequestPriority["Medium"] = "medium";
    KnowledgeRequestPriority["High"] = "high";
})(KnowledgeRequestPriority || (KnowledgeRequestPriority = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9zdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZG9tYWluL1Bvc3RzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQWFBLE1BQU0sQ0FBTixJQUFZLFlBVVg7QUFWRCxXQUFZLFlBQVk7SUFDdEIsNkJBQWEsQ0FBQTtJQUNiLDJDQUEyQixDQUFBO0lBQzNCLGlEQUFpQyxDQUFBO0lBQ2pDLG1DQUFtQixDQUFBO0lBQ25CLHFEQUFxQyxDQUFBO0lBQ3JDLG1EQUFtQyxDQUFBO0lBQ25DLG1DQUFtQixDQUFBO0lBQ25CLG1DQUFtQixDQUFBO0lBQ25CLGlEQUFpQyxDQUFBO0FBQ25DLENBQUMsRUFWVyxZQUFZLEtBQVosWUFBWSxRQVV2QjtBQVNELE1BQU0sQ0FBTixJQUFZLFdBSVg7QUFKRCxXQUFZLFdBQVc7SUFDckIsd0NBQXlCLENBQUE7SUFDekIsOEJBQWUsQ0FBQTtJQUNmLGtDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFKVyxXQUFXLEtBQVgsV0FBVyxRQUl0QjtBQVlELE1BQU0sQ0FBTixJQUFZLFlBS1g7QUFMRCxXQUFZLFlBQVk7SUFDdEIseUNBQXlCLENBQUE7SUFDekIsNkJBQWEsQ0FBQTtJQUNiLGlDQUFpQixDQUFBO0lBQ2pCLHVDQUF1QixDQUFBO0FBQ3pCLENBQUMsRUFMVyxZQUFZLEtBQVosWUFBWSxRQUt2QjtBQTJDRCxNQUFNLENBQU4sSUFBWSxRQWNYO0FBZEQsV0FBWSxRQUFRO0lBQ2xCLHlCQUFhLENBQUE7SUFDYiwyQkFBZSxDQUFBO0lBQ2YsMkJBQWUsQ0FBQTtJQUNmLDJCQUFlLENBQUE7SUFDZixxQ0FBeUIsQ0FBQTtJQUN6Qix5QkFBYSxDQUFBO0lBQ2IseUJBQWEsQ0FBQTtJQUNiLDJCQUFlLENBQUE7SUFDZiwyQkFBZSxDQUFBO0lBQ2YseUJBQWEsQ0FBQTtJQUNiLDZCQUFpQixDQUFBO0lBQ2pCLGlEQUFxQyxDQUFBO0lBQ3JDLDJDQUErQixDQUFBO0FBQ2pDLENBQUMsRUFkVyxRQUFRLEtBQVIsUUFBUSxRQWNuQjtBQUVELE1BQU0sQ0FBTixJQUFZLGdCQU1YO0FBTkQsV0FBWSxnQkFBZ0I7SUFDMUIsNkNBQXlCLENBQUE7SUFDekIsMkNBQXVCLENBQUE7SUFDdkIsbUNBQWUsQ0FBQTtJQUNmLGlEQUE2QixDQUFBO0lBQzdCLDJDQUF1QixDQUFBO0FBQ3pCLENBQUMsRUFOVyxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBTTNCO0FBK0dELE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLENBQUMsWUFBWSxDQUFDLENBQUM7QUFHL0MsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQXVCLENBQUMsV0FBVyxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsWUFBWSxDQUFDLENBQUM7QUFHNUcsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQXVCLENBQUMsV0FBVyxFQUFFLGlCQUFpQixDQUFDLENBQUM7QUFHdEYsTUFBTSxDQUFDLElBQU0sd0JBQXdCLEdBQThCLENBQUMsZUFBZSxFQUFFLGVBQWUsQ0FBQyxDQUFDO0FBR3RHLE1BQU0sQ0FBQyxJQUFNLGVBQWUsR0FBc0IsQ0FBQyxXQUFXLENBQUMsQ0FBQztBQUdoRSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBc0IsQ0FBQyxXQUFXLENBQUMsQ0FBQztBQUdqRSxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBdUIsQ0FBQyxZQUFZLENBQUMsQ0FBQztBQUdwRSxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBdUIsQ0FBQyxZQUFZLENBQUMsQ0FBQztBQUlwRSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBc0IsQ0FBQyxXQUFXLENBQUMsQ0FBQztBQUNqRSxNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBNEIsQ0FBQyxhQUFhLENBQUMsQ0FBQztBQWMvRSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBc0I7SUFDakQsaUJBQWlCO0lBQ2pCLG9CQUFvQjtJQUNwQix5RUFBeUU7SUFDekUsMEJBQTBCO0lBQzFCLG1FQUFtRTtJQUNuRSwrQkFBK0I7SUFDL0IsMkVBQTJFO0NBQzVFLENBQUM7QUFHRixNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FBMEIsQ0FBQyxhQUFhLEVBQUUsWUFBWSxFQUFFLG1CQUFtQixDQUFDLENBQUM7QUFHOUcsTUFBTSxDQUFDLElBQU0saUJBQWlCLCtEQUN6QixpQkFBaUIsU0FDakIsaUJBQWlCLFNBQ2pCLGdCQUFnQixTQUNoQix3QkFBd0IsT0FDNUIsQ0FBQztBQXlIRixNQUFNLENBQU4sSUFBWSx3QkFJWDtBQUpELFdBQVksd0JBQXdCO0lBQ2xDLHVDQUFXLENBQUE7SUFDWCw2Q0FBaUIsQ0FBQTtJQUNqQix5Q0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUpXLHdCQUF3QixLQUF4Qix3QkFBd0IsUUFJbkMifQ==